<section class="py-24 bg-base-200/50 border-t border-base-300 transition-colors">
  <div class="container mx-auto px-6 max-w-4xl">
    
    <!-- Section Header -->
    <div class="text-center mb-16 space-y-4">
      <div class="inline-flex items-center gap-2 bg-primary/10 text-primary border border-primary/20 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider">
        <i class="fa-solid fa-circle-question"></i>
        <span>Got Questions?</span>
      </div>
      <h2 class="text-3xl sm:text-4xl font-extrabold text-base-content tracking-tight">
        Frequently Asked Questions for Instructors
      </h2>
      <p class="text-base-content/70">
        Everything you need to know about teaching, streaming, and earning on Learnbird.
      </p>
    </div>

    <!-- FAQ Accordion List -->
    <div class="space-y-4">
      
      <!-- FAQ 1 -->
      <div class="daisy-collapse daisy-collapse-arrow daisy-card bg-base-100 border border-base-300 rounded-2xl shadow-sm">
        <input type="checkbox" [checked]="openFaqIndex === 0" (change)="toggleFaq(0)" />
        <div class="daisy-collapse-title text-lg font-bold text-base-content pr-12">
          Who can become an instructor on Learnbird?
        </div>
        <div class="daisy-collapse-content text-base-content/75 text-sm leading-relaxed border-t border-base-200/80 pt-4">
          <p>
            Any qualified teacher, private tutor, university lecturer, or subject matter expert in Sri Lanka can register. Whether you specialize in Grade 6-11, Ordinary Level (O/L), Advanced Level (A/L), languages, IT, or professional courses, Learnbird gives you the tools to teach online.
          </p>
        </div>
      </div>

      <!-- FAQ 2 -->
      <div class="daisy-collapse daisy-collapse-arrow daisy-card bg-base-100 border border-base-300 rounded-2xl shadow-sm">
        <input type="checkbox" [checked]="openFaqIndex === 1" (change)="toggleFaq(1)" />
        <div class="daisy-collapse-title text-lg font-bold text-base-content pr-12">
          How do live classes work with Zoom integration?
        </div>
        <div class="daisy-collapse-content text-base-content/75 text-sm leading-relaxed border-t border-base-200/80 pt-4">
          <p>
            Learnbird connects directly with Zoom. When you create a live class and set its recurring schedule, session links are automatically generated and made accessible to students who have actively subscribed or enrolled.
          </p>
        </div>
      </div>

      <!-- FAQ 3 -->
      <div class="daisy-collapse daisy-collapse-arrow daisy-card bg-base-100 border border-base-300 rounded-2xl shadow-sm">
        <input type="checkbox" [checked]="openFaqIndex === 2" (change)="toggleFaq(2)" />
        <div class="daisy-collapse-title text-lg font-bold text-base-content pr-12">
          Can I offer both live classes and pre-recorded video courses?
        </div>
        <div class="daisy-collapse-content text-base-content/75 text-sm leading-relaxed border-t border-base-200/80 pt-4">
          <p>
            Yes! You can host live interactive classes with monthly subscriptions, or publish pre-recorded video courses with structured video playlists and downloadable study materials.
          </p>
        </div>
      </div>

      <!-- FAQ 4 -->
      <div class="daisy-collapse daisy-collapse-arrow daisy-card bg-base-100 border border-base-300 rounded-2xl shadow-sm">
        <input type="checkbox" [checked]="openFaqIndex === 3" (change)="toggleFaq(3)" />
        <div class="daisy-collapse-title text-lg font-bold text-base-content pr-12">
          How do student payments and instructor payouts work?
        </div>
        <div class="daisy-collapse-content text-base-content/75 text-sm leading-relaxed border-t border-base-200/80 pt-4">
          <p>
            Students subscribe or purchase courses directly through Learnbird's secure payment system. Your instructor dashboard displays real-time enrollment statistics and income reports, with automated monthly payouts.
          </p>
        </div>
      </div>

      <!-- FAQ 5 -->
      <div class="daisy-collapse daisy-collapse-arrow daisy-card bg-base-100 border border-base-300 rounded-2xl shadow-sm">
        <input type="checkbox" [checked]="openFaqIndex === 4" (change)="toggleFaq(4)" />
        <div class="daisy-collapse-title text-lg font-bold text-base-content pr-12">
          How can I communicate with my enrolled students outside of live sessions?
        </div>
        <div class="daisy-collapse-content text-base-content/75 text-sm leading-relaxed border-t border-base-200/80 pt-4">
          <p>
            You can attach exclusive WhatsApp or Telegram group invite links to your live class configuration. These links are automatically displayed to verified enrolled students so you can maintain an active study community.
          </p>
        </div>
      </div>

    </div>
  </div>
</section>
